import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input
} from '@angular/core';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/takeUntil';

/**
 * Provides a Bootstrap-compliant modal using structural content projection and AX best practices.
 * @export
 * @class ModalComponent
 * @implements {AfterViewInit}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'pru-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit{
  modal: any;
  isHidden: any;
  /**
   * The modal container.
   * @type {ElementRef}
   * @memberof ModalComponent
   */
  @ViewChild('modalroot') modalRoot: ElementRef;
  @Input() id: any;
  @Input() fade: any;
  @Input() labelledBy: any;
  @Input() describedBy: any;

  /**
   * Creates an instance of ModalComponent.
   * @memberof ModalComponent
   */
  constructor() {
  }

  /**
   * Hook into modal events and re-emit as NG events.
   * @memberof ModalComponent
   */
  ngOnInit(): void {
    this.modal = this.modalRoot.nativeElement;
  }

  /**
   * Method to hide modal.
   * @memberof ModalComponent
   */
  hide(): void {
    this.modal.style.display = 'none';
  }

  /**
   * Method to show modal.
   * @memberof ModalComponent
   */
  show(): void {
    this.modal.style.display = 'block';
  }

  /**
   * Method to toggle hide/show.
   * @memberof ModalComponent
   */
  toggle(): void {
    if (this.modal.style.display === 'block') {
      this.modal.style.display = 'none';
    } else {
      this.modal.style.display = 'block';
    }
  }
}
